module.exports = __webpack_public_path__ + "static/media/complete.81437f37.svg";